<template>
  <div id="app">
    <loading :active.sync="preloaderStatus" color="#cd0e2d" :is-full-page="true"></loading>
    <Modal/>
    <confirm/>
    <Header/>

    <div class="bg d-flex align-items-stretch" v-if="$route.name !== 'Login'">
      <Sidebar/>
      <Content/>
    </div>
    <router-view v-else/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  import Header from './components/layouts/Header'
  import Sidebar from './components/layouts/Sidebar'
  import Content from './components/layouts/Content'
  import Modal from './components/modals/Modal'

  export default {
    components: {
      Header,
      Sidebar,
      Content,
      Modal,
      Loading,
    },
    computed: {
      ...mapGetters([
        'preloaderStatus'
      ]),
    }
  }
</script>

<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap';
  @import '../node_modules/bootstrap-vue/src/index.scss';

  @font-face {
    font-family: 'Gotham Pro Bold';
    src: url('/fonts/GothamPro-Black.eot');
    src: url('/fonts/GothamPro-Black.eot?#iefix') format('embedded-opentype'),
    url('/fonts/GothamPro-Black.woff2') format('woff2'),
    url('/fonts/GothamPro-Black.woff') format('woff'),
    url('/fonts/GothamPro-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Gotham Pro Medium';
    src: url('/fonts/GothamPro-Medium.eot');
    src: url('/fonts/GothamPro-Medium.eot?#iefix') format('embedded-opentype'),
    url('/fonts/GothamPro-Medium.woff2') format('woff2'),
    url('/fonts/GothamPro-Medium.woff') format('woff'),
    url('/fonts/GothamPro-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Gotham Pro Light';
    src: url('/fonts/GothamPro-Light.eot');
    src: url('/fonts/GothamPro-Light.eot?#iefix') format('embedded-opentype'),
    url('/fonts/GothamPro-Light.woff2') format('woff2'),
    url('/fonts/GothamPro-Light.woff') format('woff'),
    url('/fonts/GothamPro-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Gotham Pro';
    src: url('/fonts/GothamPro.eot');
    src: url('/fonts/GothamPro.eot?#iefix') format('embedded-opentype'),
    url('/fonts/GothamPro.woff2') format('woff2'),
    url('/fonts/GothamPro.woff') format('woff'),
    url('/fonts/GothamPro.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  html, body, #app { margin: 0; height: 100%; }

  #app {
    background: #f6f6f6;
    font-family: Gotham Pro, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 14px;
    .bg {
      background: #f6f6f6;
      flex-direction: row;
      min-height: 100%;
    }
  }

  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .font-default { font-family: Gotham Pro, serif; font-size: 13px; }
  .font-light { font-family: Gotham Pro Light, serif }
  .font-medium { font-family: Gotham Pro Medium, serif }
  .font-bold { font-family: Gotham Pro Bold, serif }
  .text-dark { color: #0e1012 !important }
  .cursor-pointer { cursor: pointer !important }
  .border-bottom { border-bottom: 1px solid #242729 }

  .badge-high,
  .badge-medium,
  .badge-low {
    font-family: Gotham Pro Light, serif;
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    width: 78px;
    height: 26px;
    text-transform: capitalize;
  }
  .badge-high { background-color: #f00 }
  .badge-medium { background-color: #ff6b00 }
  .badge-low { background-color: #669e0a }
  .badge-index {
    font-family: Gotham Pro Light, serif;
    width: 22px;
    height: 22px;
    padding: 6px 0 0 0;
    background: #cacaca;
    color: #fff;
    font-size: 12px;
    line-height: 11px;
  }

  // forms
  label {
    color: #828282;
  }
  .form-control {
    border: 1px solid #e6e6e6;
    height: 44px;
  }
  .password-show {
    background: url("./assets/img/eye-icon.png");
    display: block;
    height: 19px;
    width: 19px;
    position: absolute;
    bottom: 13px;
    right: 15px;
    cursor: pointer;
    &.active {
      background: url("./assets/img/eye2-icon.png");
    }
  }
  button:focus { outline: 0 }
  .btn {
    border-radius: 3px;
    border: none;
    width: 217px;
    height: 44px;
    text-transform: uppercase;
    display: block;
    font-family: Gotham Pro Bold, serif;
    font-size: 14px;
    &.btn-sm {
      width: 147px;
      height: 30px;
    }
    &.btn-primary {
      background: linear-gradient(89.7deg, #cd0e2d 2.26%, #740013 111.1%);
    }
    &.btn-create {
      font-family: Gotham Pro Medium, serif;
      border: 2px solid #828282;
      border-radius: 3px;
      color: #828282;
      font-size: 14px;
      line-height: 30px;
    }
    &.btn-outline-secondary {
      font-family: Gotham Pro Medium, serif;
      border: 2px solid #828282;
      border-radius: 3px;
      font-size: 12px;
      line-height: 13px;
      color: #828282;
      &:hover {
        background: #fff;
      }
    }
    &.btn-outline-dark {
      font-family: Gotham Pro Medium, serif;
      border: 1px solid #828282;
      border-radius: 3px;
      font-size: 12px;
      line-height: 13px;
      color: #828282;
      &:hover {
        background: #fff;
      }
    }
    &.btn-image {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      span { padding: 2px 0 0 5px }
    }
    &.btn-delete {
      width: auto;
      font-size: 16px;
    }
  }

  // tables
  .table th { font-weight: 300; color: #878889; }
  .table th, .table td {
    padding: 17px 30px;
  }

  // card
  .card {
    background: #fff;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    .card-header {
      background-color: #f6f6f6;
      color: #242729;
      padding: 20px 30px 16px;
    }
    .card-body { padding: 30px }
  }

  // vue-select
  .v-select {
    position: relative;
    .vs__dropdown-menu { overflow-x: hidden }
    .vs__dropdown-toggle {
      background: #fff !important;
      border: 1px solid #e2e2e2 !important;
      white-space: nowrap;
      display: block;
      width: 100%;
      .vs__actions {
        display: block;
        float: right;
        position: absolute;
        top: 4px;
        right: 0;
        z-index: 9;
      }
    }
    &.form-control .vs__dropdown-toggle { border: none !important }
    .vs__selected-options {
      width: calc(100% - 30px);
      .vs__selected {
        background-color: #0000;
        border-color: #0000;
        display: block;
        width: calc(100% - 20px);
        overflow: hidden;
      }
    }
    &.v-select_small {
      .vs__dropdown-toggle {
        .vs__actions {
          top: 0;
        }
      }
      .vs__selected-options {
        .vs__search, .vs__search:focus {
          font-size: 0.9em;
        }
      }
    }
  }

  // pagination
  .page-item.active .page-link {
    background-color: #850217;
    border-color: #be0b28;
  }
  .page-link {
    color: #850217;
  }
</style>
